import React, { Component } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'gatsby';
import {
  faUserCircle,
  faClipboardList,
  faPlus,
  faPrint
} from '@fortawesome/free-solid-svg-icons';
import { faEnvelope, faHeart } from '@fortawesome/free-regular-svg-icons';
import classNames from 'classnames';
import { UiStateConsumer } from '../context/UiStateContext';
import placeHolderImage from '../images/placeholder.png';
import RegularButton from './RegularButton';
import { breakpoints, colors } from '../style-utilities/variables';
import ShoppingList from './ShoppingList/ShoppingList';
import { ShoppingListStateConsumer } from '../context/ShoppingListContext';
import UserService from '../services/user.service';
import { UserStateConsumer } from '../context/UserStateContext';
import SignUpFormSimple from './Forms/SignUpFormSimple';
import ShoppingListNotes, {
  NoteSection
} from './ShoppingList/ShoppingListNotes';
import ShoppingListEmail from './ShoppingList/ShoppingListEmail';

//
import ComponentStyles from '../brand-styles/components/ShoppingListDrawer.styles';

const AddItemModal = styled.div`
  display: none;
  height: auto;
  background: white;
  margin: 10px auto;
  &.modal-open {
    display: block;
  }
  label {
    display: flex;
    margin: 10px 20px;
  }
  input,
  select {
    display: block;
    width: 90%;
    margin: 5px auto;
  }
  button {
    display: inline-block;
    margin: 20px 10px;
  }
`;

const Div = styled.div`
  /* overflow: scroll; */
  background: white;
  z-index: 200;
  padding: 20px 15px;
  /* width: 35vw; */
  right: -100%;
  visibility: hidden;
  min-height: 70vh;
  top: 0;
  position: fixed;
  transition: 0.3s right ease-out, 0.3s visibility ease-out;
  .drawer-content-wrapper {
    /* Use vh as a fallback for browsers that do not support Custom Properties */
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    .greyBox {
      padding-bottom: 1em;
      margin-bottom: 3em;
    }
  }
  .list-container {
    position: relative;
  }
  &.shop-open {
    opacity: 1;
    right: 0;
    visibility: visible;
    z-index: 600;
    @media (min-width: 768px) {
      width: 420px;
      #close-button {
        display: none;
      }
    }
  }
  #close-button {
    border: none;
    background: transparent;
  }
  #shopping-button-right {
    outline: none;
    color: ${colors.primary};
    transform: rotate(-90deg);
    left: -141px;
    top: 50%;
    background: white;
    position: absolute;
    cursor: pointer;
    border: none;
    padding: 9px 14px 14px;
    border-top: 2px solid ${colors.primary};
    border-right: 2px solid ${colors.primary};
    border-left: 2px solid ${colors.primary};
    border-bottom: transparent;
    #caret {
      width: 15px;
      fill: ${colors.primary};
    }
  }
  .top-bar {
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 50% 50%;
    grid-template-columns: repeat(2, 1fr);
    .person {
      -ms-grid-column: 1;
      grid-column: 1;
    }
    .favorite {
      -ms-grid-column: 2;
      grid-column: 2;
    }
    .person,
    .favorite {
      border: 1px solid lightgray;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      .favorite-count {
        position: relative;
      }
      a {
        color: ${colors.primary};
        text-decoration: none;
      }
      svg {
        color: ${colors.primary};
        height: 24px;
        width: 24px;
      }
    }
    .profile-icon-link {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .fa-profile-icon {
      margin-right: 8px;
    }
    button {
      margin-top: 18px;
      color: ${colors.primary};
      padding: 10px;
      border: 1px solid lightgray;
    }
    .favorite {
      display: flex;
      align-items: center;
      button {
        border: none;
        background: transparent;
      }
    }
  }
  .bottom-bar {
    display: -ms-grid;
    display: grid;
    button {
      color: ${colors.primary};
      border: 1px solid lightgray;
    }
    margin-bottom: 3em;
  }

  .main-list {
    text-align: center;
    .shoppingList-title {
      color: ${colors.primary};
      font-size: 1.5em;
      font-weight: bold;
      margin-top: 0.5em;
      margin-bottom: 0.5em;
    }
    .add-shopping-list {
      width: 90%;
      margin: 0 auto;
      box-shadow: none;
      border: 1px solid lightgray;
      color: ${colors.primary};
      text-align: left;
      padding: 10px;
      margin-bottom: 20px;
    }
  }

  @media (max-width: ${breakpoints.tablet}) {
    -webkit-overflow-scrolling: touch;
    #shopping-button-right {
      /* display: none; */
    }
    #close-button {
      display: block;
      font-weight: bold;
      padding: 0 5px;
      margin: 0 0 5px 0;
    }
    .top-bar {
      .person,
      .favorite {
        padding: 0;
      }
    }
    ${NoteSection} {
      textarea {
        height: 100px;
      }
    }
    ${AddItemModal} {
      padding: 5px;
      input,
      select {
        margin: 5px;
      }
      input,
      select {
        border: 1px solid black;
      }
      input {
        padding: 5px;
      }
      .modal-button {
        margin: 5px;
        padding: 5px 10px;
      }
    }
  }
  ${ComponentStyles}
`;

class ShoppingListDrawer extends Component {
  constructor(props) {
    super(props);
    this.userService = new UserService();
  }
  state = {
    isAddItemOpen: false,
    showEmail: false,
    ingName: '',
    qty: '',
    unit: 'units',
    viewPort: 'desktop',
    isBrowser: true
  };

  componentDidMount() {
    this.setState({
      isBrowser: typeof window !== 'undefined',
      viewPort: window.innerWidth >= 900 ? 'desktop' : 'mobile'
    });
    if (this.state.isBrowser) {
      window.addEventListener('resize', this.setViewport);
    }
  }

  componentWillUnmount() {
    if (this.state.isBrowser) {
      window.removeEventListener('resize', this.setViewport);
    }
  }

  setViewport = () => {
    this.setState({
      viewPort:
        this.state.isBrowser && window.innerWidth >= 900 ? 'desktop' : 'mobile'
    });
  };

  openAddItemHandler = () => {
    this.setState({ isAddItemOpen: !this.state.isAddItemOpen });
  };

  printModal = e => {
    e.preventDefault();
    window.print();
  };

  closeModal = event => {
    event.preventDefault();
    this.setState({ isAddItemOpen: false });
  };

  onChangeHandler = event => {
    const value = event.target.value;
    this.setState({ [event.target.name]: value });
  };
  onItemChangeHandler = event => {
    const value = event.target.value;
    //allow only characers and numbers, replace all non-matching with ''
    this.setState({ [event.target.name]: value.replace(/[^a-zA-Z ]/g, '') });
    // this.setState({ [event.target.name]: value });
  };
  //allow only pos whole nums
  onQtyChangeHandler = event => {
    const value = event.target.value;
    // Regular Expression allows only integer, fraction or decimal numbers
    const regex = /^(\d+\.?\d*$)|^(\d+\/?\d*$)/g;
    let valInt = regex.test(value);
    valInt && valInt >= 0
      ? this.setState({ [event.target.name]: value })
      : this.setState({ [event.target.name]: '' });
  };

  addToShoppingList = (event, addFn) => {
    event.preventDefault();

    const name = this.state.ingName;

    if (name) {
      // const qty = this.state.qty || 1;
      const qty = this.state.qty;
      const unit = this.state.unit;

      addFn([
        {
          name: name,
          quantity: qty,
          unit: unit
        }
      ]);
    }
    this.setState({ ingName: '', qty: '' });
  };

  setShowEmail = value => {
    this.setState({
      showEmail: value
    });
  };

  render() {
    const { isShopOpen, clicked, user } = this.props;
    const openClass = classNames({
      'shop-open': isShopOpen
    });
    const openModalClass = classNames({
      'modal-open': this.state.isAddItemOpen
    });

    return (
      <UserStateConsumer>
        {userContext => {
          const user = userContext.authenticatedUser;
          return (
            <UiStateConsumer>
              {uiStateContext => {
                return (
                  <Div className={openClass}>
                    <div className="list-container">
                      <button id="close-button" onClick={clicked}>
                        X
                      </button>
                      <button id="shopping-button-right" onClick={clicked}>
                        {/* <FontAwesomeIcon icon={faClipboardList} /> */}
                        &nbsp;
                        {this.props.siteTitle &&
                        this.props.siteTitle.includes('-es')
                          ? 'Ocultar Lista de Compras'
                          : 'Hide Shopping List'}
                        &nbsp;
                        <svg
                          id="caret"
                          xmlns="http://www.w3.org/2000/svg"
                          width="284.929"
                          height="12"
                          viewBox="0 0 284.929 284.929"
                        >
                          <path d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441 L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082 c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647 c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z" />
                        </svg>
                      </button>

                      <div className="drawer-content-wrapper">
                        {user ? (
                          <React.Fragment>
                            <div className="top-bar">
                              <div className="person">
                                {userContext.authenticatedUser ? (
                                  <Link
                                    to="/user/profile"
                                    className="profile-icon-link"
                                  >
                                    <FontAwesomeIcon
                                      icon={faUserCircle}
                                      className="fa-profile-icon"
                                    />
                                    {userContext.authenticatedUser.first_name}
                                  </Link>
                                ) : (
                                  <a
                                    href="#"
                                    className="profile-icon-link"
                                    onClick={e => {
                                      uiStateContext.toggleModal('login');
                                      e.preventDefault();
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faUserCircle}
                                      className="fa-profile-icon"
                                    />
                                    {this.props.siteTitle &&
                                    this.props.siteTitle.includes('-es')
                                      ? 'Iniciar Sesión'
                                      : 'Log In'}
                                  </a>
                                )}
                              </div>
                              <div className="favorite">
                                <FontAwesomeIcon icon={faHeart} />
                                <div className="favorite-count">
                                  {userContext.favoritesCount}
                                </div>
                                &nbsp;
                                <Link to="/user/favorites">
                                  {this.props.siteTitle &&
                                  this.props.siteTitle.includes('-es')
                                    ? 'Favoritos'
                                    : 'Favorites'}
                                </Link>
                              </div>
                            </div>
                            {!this.state.showEmail && (
                              <div className="main-list">
                                <p className="shoppingList-title">
                                  {this.props.siteTitle &&
                                  this.props.siteTitle.includes('-es')
                                    ? 'Mi Lista de Compras'
                                    : 'My Shopping List'}
                                </p>
                                <button
                                  className="add-shopping-list"
                                  onClick={this.openAddItemHandler}
                                >
                                  <FontAwesomeIcon icon={faPlus} />
                                  &nbsp;{' '}
                                  {this.props.siteTitle &&
                                  this.props.siteTitle.includes('-es')
                                    ? 'Agregar un artículo a su lista'
                                    : 'Add item to your list'}
                                </button>
                                <ShoppingListStateConsumer>
                                  {shoppingListContext => {
                                    return (
                                      <AddItemModal className={openModalClass}>
                                        <h3>Add Ingredient to Shopping List</h3>
                                        <form>
                                          <input
                                            type="text"
                                            name="ingName"
                                            placeholder="Name"
                                            onChange={this.onItemChangeHandler}
                                            value={this.state.ingName}
                                          />
                                          <input
                                            type="text"
                                            name="qty"
                                            placeholder="Quantity"
                                            onChange={this.onQtyChangeHandler}
                                            value={this.state.qty}
                                          />
                                          <select
                                            name="unit"
                                            onChange={this.onChangeHandler}
                                          >
                                            <option value="units">Units</option>
                                            <option value="pounds">
                                              Pounds
                                            </option>
                                            <option value="ounces">
                                              Ounces
                                            </option>
                                          </select>
                                          <RegularButton
                                            className="modal-button"
                                            onClick={this.closeModal}
                                          >
                                            Cancel
                                          </RegularButton>
                                          <RegularButton
                                            className="modal-button"
                                            onClick={e => {
                                              this.addToShoppingList(
                                                e,
                                                shoppingListContext.addItems
                                              );
                                            }}
                                          >
                                            Add
                                          </RegularButton>
                                        </form>
                                      </AddItemModal>
                                    );
                                  }}
                                </ShoppingListStateConsumer>

                                <ShoppingList />
                              </div>
                            )}
                            <div className="greyBox">
                              {!this.state.showEmail && <ShoppingListNotes />}
                              {!this.state.showEmail && (
                                <div className="bottom-bar">
                                  <button
                                    className="button"
                                    onClick={this.setShowEmail.bind(this, true)}
                                  >
                                    <FontAwesomeIcon icon={faEnvelope} />
                                    &nbsp;{' '}
                                    {this.props.siteTitle &&
                                    this.props.siteTitle.includes('-es')
                                      ? 'Enviar Lista de Compras por Correo Electrónico'
                                      : 'Email Shopping List'}
                                  </button>

                                  <button
                                    className="button"
                                    onClick={this.printModal}
                                  >
                                    <FontAwesomeIcon icon={faPrint} />
                                    &nbsp;{' '}
                                    {this.props.siteTitle &&
                                    this.props.siteTitle.includes('-es')
                                      ? 'Imprimir Lista de Compras'
                                      : 'Print Shopping List'}
                                  </button>
                                </div>
                              )}
                              {this.state.showEmail && (
                                <ShoppingListEmail
                                  user={user}
                                  close={this.setShowEmail.bind(this, false)}
                                />
                              )}
                            </div>
                          </React.Fragment>
                        ) : (
                          <SignUpFormSimple />
                        )}
                      </div>
                    </div>
                  </Div>
                );
              }}
            </UiStateConsumer>
          );
        }}
      </UserStateConsumer>
    );
  }
}

export default ShoppingListDrawer;
